module.exports = __webpack_public_path__ + "img/img121.cff161a7.png";